// All content, trademarks, and data on this document are the property of Healthworks Analytics, LLC and are protected by applicable intellectual property laws. Unauthorized use, reproduction, or distribution of this material is strictly prohibited.
import { memo, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getSession } from "../utils/sessionstore";

import {
  accessEmbeddedDashboard,
  userLogsAPI,
} from "../services/session.service";

import { useNavigate, useParams } from "react-router-dom";

import FullScreenLoader from "../components/loaders/FullScreenLoader";
import { getRedirectValues, storeRedirectCID } from "../utils/embedLink";
import { handleItem } from "../utils/handleItem";

const EmbeddedLinkDashboard = () => {
  const navigate = useNavigate();
  const { cid } = useParams();
  const dispatch = useDispatch();
  const [apiRunning, setApiRunning] = useState(false);

  const { userDetails, clientname, subscriptions } =
    useSelector((state) => ({
      clientname: state.clientname,
      userDetails: state.userDetails,
      isLoading: state.isLoading,
      hwai_user_token: state.hwai_user_token,
      error: state.error,
      orgs: state.orgs,
      subscriptions: state.subscriptions,
    }));

  const session_id = getSession("session_id");
  const is_final_auth = JSON.parse(getSession("isAuth"))?.value === true;

  async function checkSession() {
    storeRedirectCID(cid);
    setTimeout(async () => {
      if (!session_id) {
        navigate("/login");
      } else if (is_final_auth) {
        navigate("/hwai-login");
      } else {
        const { dashboardID } = getRedirectValues(cid);
        setApiRunning(true);
        const { dashboard, client } = await getDashboardAndClientDetails(dashboardID);
        setApiRunning(false);
        await landDashboardNew(dashboard, client._id);
      }
    }, 200);
  }

  async function landDashboardNew(dashboardObject, clientID) {
    if (!subscriptions?.length || !dashboardObject?.standarddashboardId?._id) return;
  
    const targetId = dashboardObject?.standarddashboardId?._id;
    let localProductLine = "";
  
    for (const subscription of subscriptions) {
      const categories = subscription.productcategoryIds || [];
  
      for (const category of categories) {
        const dashboards = category.dashboardIds || [];
  
        const match = dashboards.find(
          dash => dash.standarddashboardId?._id === targetId
        );
  
        if (match) {
          localProductLine = subscription.label;
          break;
        }
      }
  
      if (localProductLine) break;
    }
    await handleItem({productLine:localProductLine, clientID: clientID, userDetails: userDetails, dashboard: dashboardObject, clientName: clientname, triggerType: "EMBEDDED_DASHBOARD", pathname: window.location.pathname, dispatch: dispatch, navigate: navigate });
  }

  useEffect(() => {
    checkSession();

    const interval = setInterval(() => {
      if (!apiRunning) {
        checkSession();
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [session_id, apiRunning]);

  return <FullScreenLoader />;
};

async function getDashboardAndClientDetails(
  dasgboardID,
) {
  try {
    const response = await accessEmbeddedDashboard(dasgboardID);
    return response;
  } catch (error) {
    console.log(error);
  }
}

export { getDashboardAndClientDetails }
export default memo(EmbeddedLinkDashboard);
